import React, { useEffect, useState } from 'react';
import BACKEND_URL from '../config.js';

const API_URL = BACKEND_URL;

export default function LoginPage() {
  // Se l'utente è già loggato (token in localStorage) salta la login e va alla dashboard.
  // Eventuali token scaduti vengono gestiti da apiFetch alla prima 401 (rimuove il token
  // e riporta a "/"), quindi non serve verificare la validità qui.
  const [redirecting] = useState(() => {
    if (typeof window !== 'undefined' && localStorage.getItem('token')) {
      window.location.replace('/dashboard');
      return true;
    }
    return false;
  });

  useEffect(() => {
    // Rispetta StrictMode: il replace è già partito sopra; nulla da fare qui.
  }, []);

  if (redirecting) return null;

  return (
    <div className="login-page">

      {/* ── Sfondo animato iridescente (intera pagina) ── */}
      <div className="login-bg" aria-hidden="true">
        <div className="login-bg__mesh" />
        <div className="login-bg__grid" />
        <div className="login-brand__orb login-brand__orb--1" />
        <div className="login-brand__orb login-brand__orb--2" />
        <div className="login-brand__orb login-brand__orb--3" />
      </div>

      {/* ── Panel sinistro: brand ── */}
      <div className="login-brand" aria-hidden="true">
        <div className="login-brand__content">
          <div className="login-brand__logo">
            <img
              src={`${process.env.PUBLIC_URL}/bop-logo-reverse.svg`}
              alt="BOP"
              className="login-brand__logo-img"
            />
          </div>

          <h2 className="login-brand__headline">
            Il gestionale del<br />Gruppo Pianinvest
          </h2>
          <p className="login-brand__desc">
            Gestisci preventivi, commesse, anagrafiche e
            contabilità da un'unica piattaforma sicura, pensata
            per tutto il Gruppo.
          </p>

          <div className="login-brand__features">
            <div className="login-brand__feature">
              <span className="login-brand__feature-icon">
                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="1" y="3" width="14" height="10" rx="2" />
                  <path d="M5 3V2M11 3V2M1 7h14" />
                </svg>
              </span>
              <span className="login-brand__feature-label">Multi-società integrata</span>
            </div>
            <div className="login-brand__feature">
              <span className="login-brand__feature-icon">
                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M8 1.5 L14 4v4c0 3.5-2.5 6-6 6.5C2.5 14 0 11.5 0 8V4z" transform="translate(1,0)" />
                  <path d="M5 8l2 2 4-4" />
                </svg>
              </span>
              <span className="login-brand__feature-label">Accesso sicuro con Google OAuth</span>
            </div>
            <div className="login-brand__feature">
              <span className="login-brand__feature-icon">
                <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M2 11 L5 7 L8 9 L11 5 L14 7" />
                  <path d="M1 14h14M1 1v13" />
                </svg>
              </span>
              <span className="login-brand__feature-label">Dati aggiornati in tempo reale</span>
            </div>
          </div>
        </div>
      </div>

      {/* ── Panel destro: form ── */}
      <div className="login-form-panel">
        <div className="login-card">
          <div className="login-logo">
            <img
              src={`${process.env.PUBLIC_URL}/bop-mark.svg`}
              alt="BOP"
              className="login-logo-img"
            />
          </div>

          <h1 className="login-title">Benvenuto in BOP</h1>
          <p className="login-subtitle">
            Accedi con il tuo account Google aziendale per continuare
          </p>

          <a href={`${API_URL}/auth/google`} className="login-google-btn">
            <svg
              className="login-google-icon"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
            </svg>
            Accedi con Google
          </a>

          <div className="login-divider">Account aziendale</div>
          <p className="login-footer">
            Solo account con dominio aziendale autorizzato
          </p>
        </div>
      </div>

    </div>
  );
}
